/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleARightIcon20Solid = forwardRef('ArrowShapeTriangleARightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6 14.632V5.369a1 1 0 0 1 1.555-.832l6.947 4.632a1 1 0 0 1 0 1.664l-6.947 4.63A1 1 0 0 1 6 14.633Z" })));
});
